import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
// import Inventory from '../../components/Inventory';
import InventoryManagement from '../../components/InventoryManagement';
import DeviceAssetInformation from '../../components/DeviceAssetInformation';
import CreateGateway from '../../components/CreateGateway';
import useApi from '../../api/useApi';
import Notification from '../../components/Notification';
import '../../scrollbar.css';

function Table() {
  // const location = useLocation();
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(localStorage.user).organization.id;
  const [openCreate, setOpenCreate] = useState(false);
  const [openGateway, setOpenGateway] = useState(false);
  const [openCsv, setOpenCsv] = useState(false);
  const [onClose, setOnClose] = useState(false);
  const [selectedDevice, selectDevice] = useState('');
  const [selectedType, setSelectedType] = useState({ type: '', active: '' });
  const [{ isLoading, isError, data }, getData] = useApi();
  const [devices, setDevices] = useState([]);
  const [state, deleteDevice] = useApi();
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState();
  const [message, setMessage] = useState();
  const [formData, setFormData] = useState({ q: '', device_type: '', project_name: '', status: '' });
  const [filteredData, setFilteredData] = useState([]);
  const [stats, projectData] = useApi();
  const [project, setProject] = useState([]);
  const [bulkDevice, setBulkDevice] = useState([]);
  const [deviceList, setDeviceList] = useState([]);
  const day = 1000*60*60*24;

  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const scrollStyle = {
    backgroundColor: '#eee',
    height: '500px',
    overflowY: 'scroll',
  };

  useEffect(() => {
    user && getData(`/organization/${orgId}/devices`, 'GET');
    user && projectData(`/organization/${orgId}/projects`, 'GET');
  }, []);

  useEffect(() => {
    if (!stats.isLoading && !stats.isError && stats.data) {
      setProject(stats.data.projects);
    }
  }, [stats.isLoading, stats.isError, stats.data]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setDevices(data.devices);
      setFilteredData(data.devices);
    }
    if (isError) {
      setType('error');
      setMessage('Unable to fetch Device Detail');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const toggleOpenCsv = () => {
    setOpenCsv((prev) => !prev);
  };

  const toggleOpenGateway = () => {
    setOpenGateway((prev) => !prev);
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const handleDelete = () => {
    deleteDevice(`/devices/assets`, 'DELETE', { device: bulkDevice });
    // deleteDevice(`/device/${selectedDevice}/asset`, 'DELETE');
  };

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setBulkDevice([]);
      getData(`/organization/${orgId}/devices`, 'GET');
      setType('success');
      setOnClose(false);
      setMessage('Device Deleted Successfully');
      setNotification(!notification);
      refreshList();
    }
    if (state.isError) {
      setType('error');
      setMessage('Unable to delete Device Detail');
      setNotification(!notification);
    }
  }, [state]);

  useEffect(() => {
    if (devices.length <= 0) {
      return;
    }
    // if (formData.q === '') {
    //   setDevices(filteredData);
    // }

    if (formData.device_type === '' && formData.project_name === '' && formData.status === '') {
      setFilteredData(devices);
    }
    let z = devices;

    if (formData.project_name) {
      z = z.filter((x) => x?.device?.project?.projectName === formData.project_name);
    }

    if (formData.device_type) {
      z = z.filter((x) => x?.device?.deviceType === formData.device_type);
    }

    if (formData.status) {
      z = z.filter((x) => x?.device?.isActive.toString() === formData.status);
    }

    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        return (
          x?.device?.id?.toLowerCase().indexOf(normalizedQuery) >= 0 ||
          x?.device?.deviceType.toLowerCase().indexOf(normalizedQuery) >= 0
        );
      });
    }
    if (z.length > 0) setFilteredData(z);
    else setFilteredData([]);
  }, [formData]);

  const refreshList = () => {
    setDeviceList([]);
    setBulkDevice([]);
    selectDevice('');
    setSelectedType({
      type: '',
      active: '',
    });
    getData(`/organization/${orgId}/devices`, 'GET');
    // toggleOpenCreate();
  };
  const alertMsg = (msg) => {
    setNotification(msg);
  };

  const getTimeoffset = (ts) => {
    const _date = new Date(ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    // Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20 px-16"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white px-16 text-lg block m-auto rounded-2xl">
            <span className="block text-center mt-10 mb-8">
              Do you want to detach selected device?
            </span>
            <div className="flex justify-center items-center mb-10 font-bold text-xl">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-10 py-4 rounded-lg text-sm mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={handleDelete}
              >
                YES
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-10 py-4 rounded-lg text-sm mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setOnClose(false);
                }}
              >
                NO
              </button>
            </div>
          </div>
        </div>
      )}
      {openCreate && (
        <DeviceAssetInformation
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedDevice={selectedDevice}
          refreshList={() => refreshList()}
        />
      )}

      {openCsv && (
        <InventoryManagement
          handleClose={toggleOpenCsv}
          action={action}
          notification={createNotification}
          refreshList={() => refreshList()}
        />
      )}
      {openGateway && (
        <CreateGateway
          handleClose={toggleOpenGateway}
          action={action}
          notification={createNotification}
          selectedDevice={selectedDevice}
          refreshList={() => refreshList()}
        />
      )}

      <div
        className="h-full w-topBar fixed hideScroll"
        style={{ filter: openCreate && 'blur(2px)', left: '12%', width: '88%', overflow: 'auto' }}
      >
        <div className="z-50" style={{ height: '22vh', background: '#f9f9f9', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-xl">Devices</span>

            <div className="block lg:flex mt-1 lg:mt-0">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCsv();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                BULK UPLOAD(CSV)
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full 
                lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  if (bulkDevice.length > 1 || deviceList.length > 1) {
                    setType('error');
                    setMessage('Unable to Attach Asset, Multiple Devices Selected');
                    setNotification(!notification);
                  } else {
                    setAction('create');
                    if (
                      (selectedType.type === 'BLE_TAG' ||
                      selectedType.type === 'CATM1_TAG' ||
                      selectedType.type === '') &&
                      (!selectedType.active || selectedType.active === '')
                      )
                      toggleOpenCreate();
                    }
                  // toggleOpenCreate();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                ATTACH ASSET
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max
                 border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  if (bulkDevice.length > 1 || deviceList.length > 1) {
                    setType('error');
                    setMessage('Unable to Attach Asset, Multiple Devices Selected');
                    setNotification(!notification);
                  } else {
                  setAction('create');
                  if (
                    (selectedType.type === 'BLE_GW' || selectedType.type === '') &&
                    (!selectedType.active || selectedType.active === '')
                  )
                    toggleOpenGateway();
                  }
                }}
              >
                <img src="assets/img/Edit.svg" className="h-3 mr-2 " alt="" />
                PROVISION GATEWAY
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3
                 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  if (bulkDevice.length >= 1) setOnClose(true);
                  else {
                    setType('error');
                    setMessage('No Selected Devices to Detach');
                    setNotification(!notification);
                  }
                }}
              >
                <img src="assets/img/Delete.svg" className="h-3 mr-2 " alt="" />
                DETACH ASSET
              </button>

              <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 rounded-sm ml-3 flex justify-between items-center rounded-md">
                <input
                  type="text"
                  placeholder="Search Device"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                />
                <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl" style={{ minWidth: '700px' }}>
          <div className="bg-tableBg w-tableWidth m-auto mb-3">
            <div className="bg-tableHeader w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="flex w-full relative ">
                <div className=" py-4 text-sm font-bold w-1/3 px-10">DEVICE ID</div>
                <div className=" py-2 text-sm font-bold w-1/4">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#648299"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.device_type}
                      name="device_type"
                      className="border-2 font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-10 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-xl"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">DEVICE TYPE</option>
                      <option>BLE_TAG</option>
                      <option>CATM1_TAG</option>
                      <option>BLE_GW</option>
                    </select>
                  </div>
                </div>
                <div className=" py-2 text-sm font-bold w-1/4">
                  {' '}
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#648299"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.project_name}
                      name="project_name"
                      className="border-2 font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-10 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-xl"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">PROJECT</option>
                      {project.map((item) => (
                        <option key={item?.id}>{item?.projectName}</option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className=" py-2 text-sm font-bold w-1/5">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#648299"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border-2 font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-10 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-xl"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                <div className=" py-4 text-sm font-bold w-1/5">LAST MODIFIED</div>
                {/* <div className=" py-4 text-sm font-bold w-1/5">STATUS</div> */}
                {/* <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" /> */}
              </div>
            </div>
            {!isLoading ? (
              <div
                className="pb-1 border hideScroll"
                style={{ borderColor: '#e6e6e6', height: '77vh', overflow: 'auto' }}
              >
                {filteredData.map((item, idx) => (
                  <div className="m-2.5 bg-white flex rounded-md shadow-sm relative border-2 border-transparent hover:border-indigo-200 focus-within:border-indigo-200">
                    <input
                      key={item?.device?.id || item?.id}
                      type="checkbox"
                      className="absolute left-3 top-5"
                      id={`userCheckbox${idx}`}
                      // checked={selectedDevice === (item?.device?.id || item?.id)}
                      onClick={(e) => {
                        if (item.isActive || item.device.isActive) {
                          if (document.getElementById(e.target.id).checked) bulkDevice.push(item.id || item.device.id);
                          else {
                            var index = bulkDevice.indexOf(item.id || item.device.id);
                            if (index !== -1) {
                              bulkDevice.splice(index, 1);
                            }
                          }
                        } else {
                          if (document.getElementById(e.target.id).checked) deviceList.push(item.id || item.device.id);
                          else {
                            var index = deviceList.indexOf(item.id || item.device.id);
                            if (index !== -1) {
                              deviceList.splice(index, 1);
                            }
                          }
                          if(deviceList.length > 1 || deviceList.length <= 0) {
                            selectDevice('');
                            setSelectedType({
                              type: '',
                              active: '',
                            });
                          } else {
                            let index = 0;
                            for(let i = 0; i < filteredData.length; i++) {
                              if(filteredData[i].device.id === deviceList[0]) {
                                index = i;
                              }
                            }
                            selectDevice(filteredData[index]?.device?.id || filteredData[index]?.id);
                            setSelectedType({
                              type: filteredData[index]?.device?.deviceType || filteredData[index]?.deviceType,
                              active: filteredData[index]?.device?.isActive || filteredData[index]?.isActive,
                            });
                        }
                      }
                      }}
                    />
                    <div className="text-role px-8 py-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/3">
                      {item.device ? item?.device?.id : item?.id}
                    </div>
                    <div className="text-role py-4 pl-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/4">
                      {item?.device ? item?.device?.deviceType : item?.deviceType}
                    </div>
                    <div className="text-role py-4 pl-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/4">
                      {item?.device?.project?.projectName ? item?.device?.project?.projectName : '---'}
                    </div>
                    <div className="text-role py-4 pl-12 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/5">
                      {item?.device?.isActive || item?.isActive ? 'ACTIVE' : 'INACTIVE'}
                    </div>
                    <div className="text-role py-4 pl-2 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm w-1/5">
                    {item?.device?.DeviceInfo !== null ? getTimeoffset(item?.device?.DeviceInfo?.updatedAt): `N/A`}
                    {/* {item?.device?.DeviceInfo !== null ? Math.round((Date.now() - new Date(item?.device?.DeviceInfo?.updatedAt).getTime()) / day) !== 0 ? `${Math.round((Date.now() - new Date(item?.device?.DeviceInfo?.updatedAt).getTime()) / day)} Days Ago` : `${parseInt(Math.abs(Date.now() - new Date(item?.device?.DeviceInfo?.updatedAt).getTime()) / 36e5)} Hours Ago` : `N/A`} */}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
